export const MY_CLAIMS_TAG = 'myClaims';
export const ALL_CLAIMS_TAG = 'allClaims';
export const MY_CLAIMS_TAB_TAG = 'myClaimsTab';
